module.exports = __webpack_public_path__ + "img/katva_yes.c3238ed4.png";